// extracted by mini-css-extract-plugin
module.exports = {"inventoryAuditMainWrapper":"InventoryAuditTrail_inventoryAuditMainWrapper__3T7Ox"};